import { BffApiClientMolecule } from "@/app/api-client/store"
import type { BlockchainFilter } from "@/app/blockchains/filters/blockchain-filters-scope"
import { useSuspenseQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { useMemo } from "react"
import { getFeaturedCollectionsQueryParams } from "./get-featured-collections-query-params"

export function useFeaturedCollections(blockchainFilter: BlockchainFilter) {
  const apiClient = useMolecule(BffApiClientMolecule)
  const queryParams = useMemo(
    () =>
      getFeaturedCollectionsQueryParams(apiClient, {
        blockchain: blockchainFilter,
      }),
    [apiClient, blockchainFilter],
  )
  const queryResult = useSuspenseQuery(queryParams)

  return queryResult.data
}
